module.exports = __webpack_public_path__ + "static/media/macherel_pike_teriyakisauce.5191fd3c.jpg";